<link href="https://fonts.googleapis.com/icon?family=Material+Icons"
  rel="stylesheet">
<mat-card>
    <mat-card-header>
      <mat-card-title>
        <i class="material-icons" id="User-Stats">devices_other</i>
        
        <strong> Device Connectivity Status</strong>
      </mat-card-title>
      
    </mat-card-header>
    <br>
    <mat-card-content>
      <div class="device-div">
        
        <script type="text/javascript" src="https://www.gstatic.com/charts/loader.js"></script>
        <div id="regions_div" class="regions_div"></div>


        
      </div>
    </mat-card-content>
</mat-card>
  